import { render } from "./DistrictAutocomplete.vue?vue&type=template&id=a1dac814"
import script from "./DistrictAutocomplete.vue?vue&type=script&lang=ts"
export * from "./DistrictAutocomplete.vue?vue&type=script&lang=ts"
script.render = render

export default script